export enum UserRoles {
    ADMIN = 'Admin',
    PLANNER = 'Planner',
    ASSURER = 'Assurer',
    ANALYST = 'Analyst',
    EXPORTER = 'Exporter',
    REPORTER = 'Reporter',
    IMPORTER = 'Importer',
}
